import React, { useCallback } from 'react';
import type { LstRotinaDoDia, LstStatus } from '../types';
import type { TplOeeMetrics } from '../services/lstOeeMetrics';
import { MeuPadraoPanel } from './MeuPadraoPanel';
import { MeuPadraoOperationalPanel } from './meu-padrao/MeuPadraoOperationalPanel';
import { LstAndonBanner } from './LstAndonBanner';
import type { LstUpcomingAlert } from '../services/lstAlerts';

export interface MeuPadraoDayViewProps {
  rotinas: LstRotinaDoDia[];
  statusById: ReadonlyMap<string, LstStatus | 'pendente'>;
  busyTemplateId: string | null;
  compact: boolean;
  alerts: LstUpcomingAlert[];
  onOpenTask: (rotina: LstRotinaDoDia) => void;
  readOnly?: boolean;
  oee?: TplOeeMetrics | null;
  ielScore?: number | null;
  selectedRoutineId?: string | null;
  onSelectRoutine?: (templateId: string) => void;
  executingRoutineId?: string | null;
}

/**
 * Visão dia — a lista das rotinas do turno.
 */
export const MeuPadraoDayView = React.memo<MeuPadraoDayViewProps>(function MeuPadraoDayView({
  rotinas,
  statusById,
  busyTemplateId,
  compact,
  alerts,
  onOpenTask,
  readOnly = false,
  oee = null,
  ielScore = null,
  selectedRoutineId = null,
  onSelectRoutine,
  executingRoutineId = null,
}) {
  const handleOpen = useCallback((rotina: LstRotinaDoDia) => {
    onSelectRoutine?.(rotina.template.id);
    onOpenTask(rotina);
  }, [onOpenTask, onSelectRoutine]);

  return (
    <div className="flex h-full min-h-0 flex-col gap-1.5">
      {alerts.length > 0 && <LstAndonBanner alerts={alerts} />}

      {readOnly && (
        <p className="shrink-0 rounded-md border border-violet-200 bg-violet-50 px-2.5 py-1 text-[10px] text-violet-700 dark:border-violet-900/50 dark:bg-violet-950/30 dark:text-violet-300">
          Visualizando o padrão de um liderado — somente leitura.
        </p>
      )}

      <MeuPadraoPanel
        rotinas={rotinas}
        busyTemplateId={busyTemplateId}
        statusById={statusById}
        onOpenTask={handleOpen}
        compact={compact}
        selectedRoutineId={selectedRoutineId}
        executingRoutineId={executingRoutineId}
      />

      <MeuPadraoOperationalPanel
        rotinas={rotinas}
        statusById={statusById}
        oee={oee}
        ielScore={ielScore}
      />
    </div>
  );
});

export default MeuPadraoDayView;
